// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".emphasized[data-v-a7022e9a]{color:red}.notion[data-v-a7022e9a]{font-weight:700}", ""]);
// Exports
module.exports = exports;
